export const faqItems = [
  {
    id: '1',
    question: '男同网是一个什么样的平台？',
    answer: '男同网是专为男同群体打造的综合性平台，提供男同交友、社群互动、生活资讯、健康指南及活动信息等服务。我们致力于为男同群体创建一个安全、包容、温暖的线上家园。',
  },
  {
    id: '2',
    question: '如何在男同网上交友？',
    answer: '您可以通过浏览我们的交友资讯文章学习交友技巧和安全知识，也可以参与社群互动板块与其他成员交流。我们提供丰富的交友指南和安全建议，帮助您更自信地拓展社交圈。',
  },
  {
    id: '3',
    question: '平台的健康资讯可信吗？',
    answer: '我们的健康指南内容由专业医疗顾问审核，参考权威医疗机构发布的信息。但请注意，平台内容仅供参考，如有具体健康问题，请咨询专业医生。',
  },
  {
    id: '4',
    question: '如何获取最新的男同活动信息？',
    answer: '您可以关注我们网站的活动信息板块，我们会定期更新全国各地的男同相关活动，包括骄傲月、社群聚会、文化讲座等。建议收藏网站并定期访问。',
  },
  {
    id: '5',
    question: '在平台上分享个人信息安全吗？',
    answer: '男同网高度重视用户隐私保护。我们建议用户在社群互动中谨慎分享个人敏感信息，如在交友过程中遇到骚扰或不妥行为，请及时向我们举报。',
  },
  {
    id: '6',
    question: '我可以投稿吗？',
    answer: '当然可以！我们欢迎社群成员分享自己的故事、经验和观点。请通过关于我们页面的联系方式与我们取得联系，我们的编辑团队会审核并回复您的投稿。',
  },
];